import { FC, ReactNode, useEffect } from 'react'
import systemColorsService from './colorService'
import { themes } from './themes.color'

const ThemeProvider: FC<Props> = (props: Props) => {
  const theme = 'light'

  useEffect(() => {
    systemColorsService.setColors(themes[theme])

    localStorage.setItem('theme', theme)
  }, [theme])

  return <>{props.children}</>
}

interface Props {
  children?: ReactNode
}

export default ThemeProvider
